export interface ResolveParams {
  clientId: number;
  modelId: number;
  instanceId: number;
  scenarioId: number;
  submissionId: number;
}

export const RESOLVE_PATH = '/scenario-manager/resolve-conflicts';

// Route IDs are untrusted input; validate with allowlist rather than coerce.
export const parseResolveParams = (search: string): ResolveParams | null => {
  const params = new URLSearchParams(search);
  const keys = ['client', 'model', 'instance', 'scenario', 'submission'];

  const values: Record<string, number> = {};

  for (const key of keys) {
    const value = params.get(key);
    if (!value || !/^\d+$/.test(value)) {
      return null;
    }
    const num = Number(value);
    if (num <= 0) {
      return null;
    }
    values[key] = num;
  }

  return {
    clientId: values.client,
    modelId: values.model,
    instanceId: values.instance,
    scenarioId: values.scenario,
    submissionId: values.submission,
  };
};

export const buildResolvePath = (params: ResolveParams): string => {
  const queryParams = new URLSearchParams({
    client: String(params.clientId),
    model: String(params.modelId),
    instance: String(params.instanceId),
    scenario: String(params.scenarioId),
    submission: String(params.submissionId),
  });
  return `${RESOLVE_PATH}?${queryParams.toString()}`;
};

export const resolvePathFromSearch = (
  search: string,
  submissionId: number
): string => {
  // Not `filterSearch` from src/utils/misc.ts: lodash `keys()` cannot
  // enumerate a URLSearchParams, so that helper drops nothing.
  const source = new URLSearchParams(search);
  const params = new URLSearchParams();
  for (const key of ['client', 'model', 'instance', 'scenario']) {
    const value = source.get(key);
    if (value !== null) {
      params.set(key, value);
    }
  }
  params.set('submission', String(submissionId));
  return `${RESOLVE_PATH}?${params.toString()}`;
};
